"use strict";

require("core-js/modules/es.array.iterator");

var go1 = require("../Strict/go1.js");

module.exports = ([a, b]) => go1(a, _a => go1(b, _b => [_b, _a]));